import { playerService } from '../services/player';
import { message } from 'antd';

let sleepTimerTimeout: NodeJS.Timeout | null = null;
let activeTimerLabel: string | null = null;

const onAudioEnded = () => {
  playerService.pausePlayback();
  clearSleepTimer();
  message.info('Sleep timer: End of track reached');
};

export const clearSleepTimer = () => {
  if (sleepTimerTimeout) {
    clearTimeout(sleepTimerTimeout);
    sleepTimerTimeout = null;
  }
  const audio = (playerService as any).audio;
  if (audio) {
    audio.removeEventListener('ended', onAudioEnded);
  }
  activeTimerLabel = null;
};

export const setSleepTimer = (minutes: number | 'end_of_track' | null) => {
  clearSleepTimer();

  if (minutes === null) {
    message.info('Sleep timer turned off');
    return;
  }

  if (minutes === 'end_of_track') {
    activeTimerLabel = 'End of track';
    const audio = (playerService as any).audio;
    if (audio) {
      audio.addEventListener('ended', onAudioEnded, { once: true });
    }
    message.success('Sleep timer set for end of track');
    return;
  }

  activeTimerLabel = `${minutes} min`;
  message.success(`Sleep timer set for ${minutes} minutes`);

  sleepTimerTimeout = setTimeout(() => {
    playerService.pausePlayback();
    clearSleepTimer();
    message.info('Sleep timer: Playback paused');
  }, minutes * 60 * 1000);
};

export const isSleepTimerActive = () => activeTimerLabel !== null;
export const getActiveTimerLabel = () => activeTimerLabel;
